import { Filter } from "../../types";
import { EditorFilter, EditorFilterMessageTypes } from "../types";
import { buildEditorFilter } from "./buildEditorFilter";
import { buildFilterFromEditorFilter } from "./buildFilterFromEditorFilter";
import { validateEditorFilter } from "./validateEditorFilter";

// // // //

export function removeFiltersWithMissingValue(
    filter: EditorFilter,
): EditorFilter {
    filter.nested = filter.nested.filter((nestedFilter) => {
        const hasMissingValueMessage = nestedFilter.messages.some(
            (message) => message.type === EditorFilterMessageTypes.missingValue,
        );

        if (hasMissingValueMessage) {
            return false; // Exclude the filter with 'missingValue' message from the nested filters
        } else {
            removeFiltersWithMissingValue(nestedFilter); // Recursively remove from nested filters
            return true; // Include the filter in the nested filters
        }
    });

    return filter;
}

/**
 * sanitizeFilter
 * Recursively sanitizes a Filter instance
 * NOTE - this should be updated to accept FilterMetadata[] for more thoughtful sanitization
 */
export function sanitizeFilter(filter: Filter | undefined): Filter | undefined {
    if (filter === undefined) {
        return undefined;
    }

    return buildFilterFromEditorFilter(
        removeFiltersWithMissingValue(
            validateEditorFilter(buildEditorFilter({ filter, isRoot: true })),
        ),
    );
}
